module.exports = __webpack_public_path__ + "public/files/img/pie-chart.7d2b6c58.png";